import { z } from "zod";

import { useErrorNotifier } from "components/instrumentation/source";
import { useExperiments } from "components/store/source/context/ExperimentsContext";

const valueSchema = z.enum([
  "on",
  "off",
  "maintenance",
  "service_interruption_updated",
  "communications_down",
  "booking_unavailable",
  "slow_response",
]);

const alertBannerExperimentSchema = z.object({
  key: valueSchema,
  value: valueSchema.nullable(),
  payload: z
    .object({
      heading: z.string(),
      description: z.string(),
      startTimestamp: z.number().optional(),
      endTimestamp: z.number().optional(),
    })
    .optional(),
  metadata: z.object({}).optional(),
});

export const useAlertBannerExperiment = () => {
  const { getExperiment } = useExperiments();
  const errorNotifier = useErrorNotifier();

  try {
    const experiment = getExperiment("alert-banner");
    if (!experiment) {
      return null;
    }

    return alertBannerExperimentSchema.parse(experiment);
  } catch (error) {
    errorNotifier.notify(
      error?.message ?? "alertBannerExperiment parse failed",
    );
    return null;
  }
};
